export class CopyBackgroundInfoOption {
  id: number;
  identifier: string;
  uncontrolled?: boolean;
}
